import React from 'react';
import { useTranslation } from 'react-i18next';
import { X, Sparkles, FileText } from 'lucide-react';

interface CreatePostModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateWithAI: () => void;
  onCreateManually: () => void;
}

export const CreatePostModal: React.FC<CreatePostModalProps> = ({
  isOpen,
  onClose,
  onCreateWithAI,
  onCreateManually
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleCreateWithAI = () => {
    onCreateWithAI();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-25" onClick={onClose} />
        
        <div className="relative bg-white rounded-xl shadow-xl max-w-md w-full p-6 border border-black">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold">{t('posts.createPost', 'Create Post')}</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <button
              onClick={handleCreateWithAI}
              className="flex flex-col items-center justify-center p-4 rounded-lg border border-primary-600 bg-primary-50 hover:bg-primary-100 hover:border-primary-700 transition-all duration-200 h-full"
            >
              <Sparkles className="w-8 h-8 text-primary-600 mb-3" />
              <div className="text-center">
                <div className="font-medium text-primary-900">{t('posts.createWithAI', 'Create with AI')}</div>
                <div className="text-sm text-primary-600">{t('posts.createWithAIDescription', 'Let AI help you create engaging content')}</div>
              </div>
            </button>

            <button
              onClick={onCreateManually}
              className="flex flex-col items-center justify-center p-4 rounded-lg border border-black hover:border-gray-700 hover:bg-gray-50 transition-all duration-200 h-full"
            >
              <FileText className="w-8 h-8 text-gray-600 mb-3" />
              <div className="text-center">
                <div className="font-medium text-gray-900">{t('posts.createManually', 'Create Manually')}</div>
                <div className="text-sm text-gray-600">{t('posts.createManuallyDescription', 'Write your own content from scratch')}</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};